import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { loadTracking, trackPageView, ffTrack } from "@/lib/tracking";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) { el?.remove(); return; }
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) { el?.remove(); return; }
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
  el.setAttribute("href", href);
}

function setSchema(list) {
  document.head.querySelectorAll('script[data-ff-seo="jsonld"]').forEach((n) => n.remove());
  (list || []).forEach((obj) => {
    const s = document.createElement("script");
    s.type = "application/ld+json"; s.setAttribute("data-ff-seo", "jsonld");
    s.textContent = JSON.stringify(obj).replace(/</g, "\\u003c");
    document.head.appendChild(s);
  });
}

function apply(m) {
  document.title = m.title || document.title;
  document.documentElement.lang = m.language || "en";
  setMeta("name", "description", m.description);
  setMeta("name", "keywords", m.keywords);
  setMeta("name", "robots", (m.robots || "index,follow").replace(",", ", "));
  setCanonical(m.canonical);
  setMeta("property", "og:site_name", m.site_name);
  setMeta("property", "og:type", m.og_type || "website");
  setMeta("property", "og:title", m.og_title);
  setMeta("property", "og:description", m.og_description);
  setMeta("property", "og:url", m.canonical);
  setMeta("property", "og:image", m.og_image);
  setMeta("name", "twitter:card", m.twitter_image ? "summary_large_image" : "summary");
  setMeta("name", "twitter:title", m.twitter_title || m.og_title);
  setMeta("name", "twitter:description", m.twitter_description || m.og_description);
  setMeta("name", "twitter:image", m.twitter_image);
  setMeta("name", "twitter:site", m.twitter_handle);
  setSchema(m.schema);
}

export default function SeoHead() {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const seq = useRef(0);
  useEffect(() => {
    const id = ++seq.current;
    if (!pathname.startsWith("/admin")) loadTracking();
    api.get("/seo/meta", { params: { path: pathname } }).then(({ data }) => {
      if (id !== seq.current) return;
      if (data.redirect) { nav(data.redirect, { replace: true }); return; }
      apply(data);
      if (!pathname.startsWith("/admin")) {
        trackPageView(pathname, data.title);
        if (data.og_type === "book") ffTrack("ViewContent", { content_name: data.og_title, content_type: "product" });
      }
    }).catch(() => {});
  }, [pathname]); // eslint-disable-line
  return null;
}
